import { useMemo } from 'react';
import { GroupBase } from 'react-select';

import { RegistryValue } from '@/react/kubernetes/helm/components/HelmRegistrySelect';

import { Option } from '@@/form-components/PortainerSelect';

export function useIsRegistryAvailable(
  selectedRegistry: RegistryValue | null,
  registryOptions: GroupBase<Option<RegistryValue>>[]
) {
  return useMemo(() => {
    // skip the check if no registry is selected
    if (!selectedRegistry) {
      return true;
    }

    const allOptions = registryOptions.flatMap((option) => option.options);
    return allOptions.some(
      (option) =>
        option.value.registryId === selectedRegistry?.registryId &&
        option.value.registryUrl === selectedRegistry?.registryUrl
    );
  }, [selectedRegistry, registryOptions]);
}
